<div class="card">
  <div class="card-header card-header-rose card-header-icon">
    <div class="card-icon">
      <i class="material-icons">assignment</i>
    </div>
    <h4 style="cursor: pointer" class="card-title" (click)="containerHDDLink()">
      HDD Link to Master Item
      <i class="material-icons"> toggle_on </i>
    </h4>
  </div>
  <div class="card-body">
    <div class="row" *ngIf="statusContainerHDDLink">
      <div class="col-md-12">
        <form>
          <div class="form-check">
            <label class="form-check-label">
              <input
                [checked]="multipleHDD"
                (change)="changeStatus(multipleHDD)"
                class="form-check-input"
                type="checkbox"
                value=""
              />
              Add Multiple HDD
              <span class="form-check-sign">
                <span class="check"></span>
              </span>
            </label>
          </div>
          <div class="row">
            <div
              id="hdLinkToMastershowMsgSearching"
              style="display: none"
              class="alert alert-info"
              role="alert"
            >
              <i style="color: white" class="material-icons"> sync </i>
              Please wait, searching in progress
            </div>
            <div
              *ngIf="this.hdlinkshowEmptySearch == 1"
              id="hdlinkshowEmpty"
              class="alert alert-danger"
              role="alert"
            >
              <i style="color: white" class="material-icons"> cancel </i>
              {{ msgerrorhdlinkSearch }}
            </div>
          </div>

          <div class="form-group">
            <mat-form-field class="example-full-width">
              <input
                type="text"
                [(ngModel)]="companySelected"
                placeholder="Company Name"
                aria-label="Company Name"
                matInput
                [formControl]="myControlCompanies"
                [matAutocomplete]="autoCompanies"
                id="nameCompany"
                required
              />
              <mat-autocomplete
                (optionSelected)="OnHumanSelected($event.option)"
                #autoCompanies="matAutocomplete"
              >
                <mat-option
                  *ngFor="let option of filteredCompanies | async"
                  [value]="option.name"
                >
                  {{ option.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <input
              type="text"
              placeholder="Company Name"
              class="form-control"
              [(ngModel)]="companySelected2"
              name="companyInput"
              id="companyInput"
              style="display: none"
              readonly
            />
          </div>

          <div class="form-group">
            <label>PO#</label>
            <select
              (change)="selectChangeHandler($event)"
              id="poform"
              name="hdlinkposelect"
              [(ngModel)]="this.hdlinkpo"
              #hdlinkposelect="ngModel"
              placeholder="Client Name"
              class="form-control"
              required
            >
              <option value="">Select PO#</option>
              <option *ngFor="let po of poList" [value]="po.id">
                {{ po.po }}
              </option>
            </select>

            <input
              type="text"
              placeholder="PO"
              class="form-control"
              [(ngModel)]="poSelected"
              name="poInput"
              id="poInput"
              style="display: none"
              readonly
            />
          </div>

          <input
          *ngIf="this.poSelected"
            type="text"
            (keyup)="searchInterest($event)"
            id="SerialNumberMasterItem"
            placeholder="Serial Number of Master Item"
            class="form-control"
            [(ngModel)]="this.SerialNumberMasterItem"
            name="SerialNumberMasterItem"
          />

          <input
          *ngIf="this.poSelected"
            type="text"
            (keyup)="searchInterest2($event)"
            id="childAssetag"
            placeholder="Asset Tag of Master Item"
            class="form-control"
            [(ngModel)]="this.childAssetag"
            name="childAssetag"
          />
          <form>
            <input
            *ngIf="this.poSelected"
              type="text"
              id="childitemSerialNumber"
              placeholder="Serial Number of HDD or SDD"
              class="form-control"
              [(ngModel)]="this.childitemSerialNumber"
              name="childitemSerialNumber"
            />

            <button
              *ngIf="!multipleHDD && this.poSelected"
              class="btn btn-success"
              (click)="AddToMaster()"
            >
              Link to Master Item
            </button>
            <button
              *ngIf="multipleHDD"
              class="btn btn-success"
              (click)="AddToChild()"
            >
              Multiple HDD
            </button>
          </form>
        </form>

        <div
          *ngIf="this.hdlinkshowEmpty == 1"
          id="hdlinkshowEmpty"
          class="alert alert-danger"
          role="alert"
        >
          <i style="color: white" class="material-icons"> cancel </i>
          {{ msgerrorhdlink }}
        </div>

        <div
          *ngIf="this.addToMastershowMsgInfoResults == 1"
          id="addToMastershowMsgInfoResults"
          class="alert alert-info"
          role="alert"
        >
          <i style="color: white" class="material-icons"> cancel </i>
          This element already exists in master item.
        </div>
      </div>
    </div>
    <div class="row" style="display: none" id="hdlinktoMasterdresults">
      <div class="col-md-12" style="line-height: 30px">
        <div class="row">
          <div class="col-md-4">
            <h3>Elements</h3>
          </div>
          <div class="col-md-4" style="position: relative">
            <div style="position: absolute; bottom: 1px; font-size: 1rem">
              Master Items with HDD: <b>{{ contMasterItemHDD }}</b>
            </div>
          </div>
          <div class="col-md-4" style="position: relative">
            <div style="position: absolute; bottom: 1px; font-size: 1rem">
              Master Items without HDD:
              <strong>{{ contMasterItemNOTHDD }}</strong>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-1 bg-light">ID</div>
          <div class="col-md-3 bg-light">Serial Number of Master Item</div>
          <div class="col-md-3 bg-light">Asset Tag</div>
          <div class="col-md-3 bg-light">Serial Number</div>

          <div class="col-md-2 bg-light">Delete</div>
        </div>
        <div
          class="row"
          *ngFor="let row of this.responseHdLinkToMaster; index as i"
          style="border-top: 1px solid #eee"
        >
          <div class="col-md-1">
            <strong>{{ i + 1 }}</strong>
          </div>
          <div class="col-md-3">
            {{ row.SerialNumberMAster }}
          </div>

          <div class="col-md-3">
            {{ row.AssetTag }}
          </div>

          <div class="col-md-3" style="font-weight: bold">
            {{ row.SerialNumber }}
          </div>
          <div class="col-md-2">
            <i *ngIf="removing === row.id" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            <button *ngIf="removing !== row.id" class="btn btn-link btn-danger btn-just-icon" (click)="removeElementFromHDLinkTable(row)" [disabled]="removing !== null">
              <i class="fa fa-trash-o" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
